import * as React from 'react';
import cx from 'classnames';

export enum Indicator {
	Valid,
	Invalid,
	Loading,
	None,
}

export interface IProductValidationIndicator {
	valid: Indicator;
}

export default class ProductValidationIndicator extends React.PureComponent<IProductValidationIndicator> {
	public render() {
		const { valid } = this.props;

		const iconClasses = cx(
			'fa',
			valid === Indicator.Invalid ? 'fa-close' : '',
			valid === Indicator.Valid ? 'fa-check' : '',
			valid === Indicator.Loading ? 'fa-spinner fa-spin' : ''
		);

		const element =
			valid != null ? (
				<i className={iconClasses} />
			) : (
				<React.Fragment>&nbsp;</React.Fragment>
			);

		return element;
	}
}
